$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * autocomplete
    // *
    // *
    $(".js-autocomplete-input").on("input", function () {
        let value = $(this).val()
            .toLowerCase()
            .trim()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, "")
        let hasMatch = false;

        // Erst mal alles ausblenden
        $(".js-autocomplete-items").hide();

        if (value.length >= 2) {
            $(".js-autocomplete-items").each(function () {
                let text = $(this).text().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, "");
                let ingredient = $(this).attr("data-ingredient").toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, "");

                if (text.startsWith(value) || ingredient.startsWith(value)) {
                    $(this).show();
                    hasMatch = true;
                }
            });
        }

        // Container nur anzeigen, wenn Treffer und mindestens 2 Zeichen
        if (hasMatch) {
            $(".js-autocomplete").addClass("active");
        } else {
            $(".js-autocomplete").removeClass("active");
        }
    });

    $(document).on("click", ".js-search-submit-button", function (e) {
        e.preventDefault();
        var firstShownElement = $(".js-autocomplete-form").find(".js-autocomplete-items").filter(function () {
            return $(this).css("display") !== "none";
        }).first();

        if (firstShownElement.length !== 0) {
            firstShownElement.click();
        }
        else {
            if ($(".js-autocomplete-input").val().length === 0) {
                hideSearchResultMessage();
            }
            // no results in list found
            else {
                showSearchResultMessage('warning');
            }
        }
    });

    $(document).on("click", ".js-autocomplete-items", function (e) {
        e.preventDefault();
        handleSelection($(this));
    });

    $(document).on("keydown", ".js-autocomplete-items", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSelection($(this));
        }
    });

    $(document).on("input change", ".js-autocomplete-input", function (e) {
        $(".js-search-submit-button").prop("disabled", false);
        if ($(this).val().length <= 1) {
            hideSearchResultMessage();
        }
    });


    function handleSelection($item) {
        let value = $item.text();
        let code = $item.attr("data-atc");
        $(".js-autocomplete-input").val(value).trigger("change");
        $(".js-autocomplete").removeClass("active");

        // Store the code and submit
        $(".js-autocomplete-form").data("currentCode", code).submit();
    }


    let atcCodesRelevant = JSON.parse($(".js-autocomplete-form").attr("data-list"));
    let atcCodesNotRelevant = JSON.parse($(".js-autocomplete-form").attr("data-list-not"));

    $(".js-autocomplete-form").on("submit", function (e) {
        e.preventDefault();
        hideSearchResultMessage();

        // prevent searching again after submit whit button; gets enabled again on search
        $(".js-search-submit-button").prop("disabled", true);

        let currentCode = $(this).data("currentCode");
        // currentCode can have multiple values -> make array
        let currentCodes = currentCode ? currentCode.split(",").map(s => s.trim()) : [];
        // console.log(currentCodes)


        var value = $(".js-autocomplete-input").val(),
            searchValue = value.toLowerCase().trim(),
            status = '';

        if (searchValue.length === 0) {
            return;
        }

        if (currentCodes.some(code => atcCodesNotRelevant.includes(code))) {
            showSearchResultMessage('danger');
            return;
        }
        else if (currentCodes.some(code => atcCodesRelevant.includes(code))) {
            showSearchResultMessage('success');
            return;
        }
        else{
            showSearchResultMessage('danger');
        }

        // $(".js-search-title").html(value);
        $(this).data("currentCode", null);
    });

    // close autocomplete on mouseleave
    $(".js-autocomplete-form").on("mouseleave", function () {
        $(".js-autocomplete").removeClass("active");
    });


    function hideSearchResultMessage() {
        $(".js-search-message").removeClass("active");
    };

    function showSearchResultMessage(status) {
        $(`.js-search-message-${status}`).addClass("active");
    };


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * language switcher
    // *
    // *
    $(".js-header-language-button").click(function () {
        const $content = $(this).siblings(".js-header-language-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * headline link 
    // *
    // *
    $('[data-jumpto]').on('click keydown', function (e) {
        // Check if it's a click or Enter key (key code 13)
        if (e.type === 'click' || e.which === 13 || e.keyCode === 13) {
            e.preventDefault(); // Prevent default action

            var targetId = $(this).data('jumpto'); // Get the target ID from data attribute

            $('html, body').scrollTop($(targetId).offset().top);
        }
    });

});